import { SecurityLevel } from '@/modules/secrets/constants';
import { IconType } from '@/modules/ui';

export const iconTypeBySecurityLevel = {
    [SecurityLevel.EXTRA_WEAK]: IconType.STATUS_ALERT,
    [SecurityLevel.WEAK]: IconType.STATUS_ALERT,
    [SecurityLevel.AVERAGE]: IconType.STATUS_WARNING,
    [SecurityLevel.STRONG]: IconType.STATUS_BOLT,
    [SecurityLevel.EXTRA_STRONG]: IconType.STATUS_OK,
};
